import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { amendmentKeys } from './amendmentQueryKeys'
import { fetchAmendmentDetail } from '../service/amendmentService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'

export const useAmendmentDetailQuery = (amendmentId?: number) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario } = useSelector(filtersSelector)

  return useQuery({
    queryKey: amendmentKeys.detail({
      companyId,
      amendmentId,
      budgetingScenarioId: budgetingScenario?.id
    }),
    queryFn: fetchAmendmentDetail,
    enabled: !!companyId && !!amendmentId
  })
}
